"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// to-do: check with Uday the different payment status
exports.default = {
    SUCCESS: 'SUCCESS',
    PENDING: 'PENDING',
    FAILED: 'FAILED',
    TIMED_OUT: 'TIMED_OUT', // custom error types for poll timeout
};
